import { useEffect, useState } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import { Link as A, IconButton} from "@mui/material";
import moment from "moment";
import { Check, Close, Download } from "@mui/icons-material";

export default function Signatures(){
    
    const columns = [
        {
            field: 'createdAt',
            headerName: 'Créée le',
            width: 160,
            type: 'date',
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated  &&
                moment(p.row.createdAt).format('DD/MM/YYYY à HH:mm'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'title',
            headerName: 'Libellé',
            width: 200,
            type: 'string',
            valueGetter: p => p.row.title,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'name',
            headerName: 'Signataire',
            width: 200,
            type: 'string',
            valueGetter: p => p.row.name,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 200,
            type: 'string',
            valueGetter: p => p.row.email,
            renderCell: p => <A href={'mailto:' + p.value}>{p.value}</A>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'phone',
            headerName: 'Tél',
            width: 150,
            type: 'string',
            valueGetter: p => p.row.phone,
            renderCell: p => p.value ? <A href={'tel:' + p.value}>{p.value}</A> : '',
            aggregable: false,
            groupable: false,
        },
        {
            field: 'signed',
            headerName: 'Signé',
            width: 60,
            type: 'bool',
            valueGetter: p => p.row.signed,
            renderCell: p => p.value ? 
                <Check color='info'/> :
                <Close color='error'/>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'signedAt',
            headerName: 'Signé le',
            width: 160,
            type: 'date',
            valueGetter: p => p.row.signedAt ? moment(p.row.signedAt).toDate() : null,
            renderCell: p => p.value ? moment(p.row.signedAt).format('DD/MM/YYYY à HH:mm') : '',
            aggregable: false,
            groupable: false,
        },
        {
            field: 'reference',
            headerName: 'Référence',
            width: 150,
            type: 'string',
            valueGetter: p => p.row.reference,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'url',
            headerName: '',
            width: 60,
            type: 'string',
            valueGetter: p => p.row.url,
            renderCell: p => 
                <IconButton size="small" href={p.value} target="_blank" rel="noopener noreferrer">
                    <Download />
                </IconButton>,
            aggregable: false,
            groupable: false,
        },
    ];


    const [items, setItems] = useState(null)

   
    useEffect(() => {

        API.get('/signatures')
            .then(r => setItems(
                r.data.sort((a,b) => b.createdAt > a.createdAt ? 1 : -1))
            )
            .catch(e => console.log(e.response?.data))

    }, [])



    return <Layout tab='signatures' menu='crm' title='Signatures électroniques'>

        <Grid 
            id='signaturesGrid'
            columns={columns}
            rows={items}
            toolbar
        />

    </Layout>

}


